<svg
  [attr.width]="size"
  [attr.height]="size"
  [class.ui-icon--flip]="flip"
  aria-hidden="true"
  focusable="false"
>
  <use [attr.href]="href"></use>
</svg>
